import { roundToDecimals } from './roundToDecimals';
import { isCloseTo } from './isCloseTo';

/**
 * Rounds a number up to the closest multiple of the provided `multiple`
 * @param numToRound
 * @param multiple - the target multiple to round up to. E.g. ceil-ing 7 to a multiple of 5 would be 10.
 * @param precision - target precision to ceil to, default is 5 decimal places
 */
export const ceilToMultiple = (
  numToRound: number,
  multiple: number,
  precision = 5
) => {
  if (
    multiple === 0 ||
    multiple === numToRound ||
    numToRound % multiple === 0
  ) {
    return numToRound;
  }

  const remainderRemoved: number = numToRound - (numToRound % multiple);

  // Float math can sometimes yield results that are a fraction of a decimal off of the true target multiple
  // rounding to a high degree of precision eliminates these instances
  if (numToRound < 0 && isCloseTo(remainderRemoved, 0, precision)) {
    return 0;
  }

  if (remainderRemoved < 0) {
    return roundToDecimals(remainderRemoved, precision);
  }

  return roundToDecimals(remainderRemoved + multiple, precision);
};
